import React from 'react'
import Counter from "../../../components/counter";

export default function ScreenBarPartner({context,campagneData}){

    const partnerMontant=campagneData?.partnerMontant || 1
    const total=campagneData.stats.total.sum.total/partnerMontant

    return (
        <div style={{
            position:"absolute",
            // Asset 11 (2962x1769) : la zone dorée du bloc compteur occupe en bas-droite,
            // approximativement y: 50%-100%, x: 50%-95%
            top:"45%",
            right:"-2%",
            width:"45%",
            height:"50%",
            display:"flex",
            justifyContent:"center",
            alignItems:"center",
            pointerEvents:"none"
        }}>
            <span style={{
                fontFamily:"PlayfairDisplay-MediumItalic",
                fontStyle:"italic",
                color:"#F4EDDC",
                fontSize:"20vh",
                lineHeight:1
            }}>
                <Counter number={total} decimals={0} preserveValue/>
            </span>
        </div>
    )
}
